import React, { useState } from 'react';
import { Flex } from '@components/Flex';
import { Columns } from '@components/Columns';
import { CTALink } from '@components/CTALink';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import {
  MatchingStationeryWrapper,
  SaveTheDatesTextPairing,
  StyledCtaColumns,
  CtaColumnLeft,
  CtaColumnRight,
  CloudImageWrapper,
  StaticPlaceholderCloudImage,
  TopPlaceholderCloudImage,
  BottomPlaceholderCloudImage,
  MobilePlaceholderCloudImage,
  BottomWave,
  MobBoxContainer,
  DesktopBoxContainer,
} from './MatchingStationerySection.styles';
import { useTranslation } from 'react-i18next';

export const MatchingStationerySection: React.FC = () => {
  const sectionId = 'Matching_Stationery_Section';
  const { t } = useTranslation('weddingWebsitePage');
  const matchingStationeryData = t('sections.matchingStationery');

  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleMobile, setIsVisibleMobile] = useState(false);

  return (
    <MatchingStationeryWrapper as={'section'} paddingTop={[10, 12]} paddingBottom={[10, 12]} id={sectionId}>
      <DesktopBoxContainer>
        <LazyLoadWrapper beforeLoad={() => setIsVisible(true)} threshold={0}>
          <div />
        </LazyLoadWrapper>
      </DesktopBoxContainer>
      <MobBoxContainer>
        <LazyLoadWrapper beforeLoad={() => setIsVisibleMobile(true)} threshold={0}>
          <div />
        </LazyLoadWrapper>
      </MobBoxContainer>
      <Columns>
        <Columns.Column width="full">
          <Flex
            alignItems={'center'}
            flexDirection={'column'}
            style={{ maxWidth: 780, marginLeft: 'auto', marginRight: 'auto' }}
            marginBottom={[8]}
          >
            <SaveTheDatesTextPairing
              alignment={'center'}
              eyebrow={matchingStationeryData.eyebrow}
              eyebrowTagName="h2"
              eyebrowColor="humanaDark4"
              eyebrowVariant="sectionEyeBrow24"
              title={matchingStationeryData.title}
              titleTagName={'h2'}
              titleColor={'neutra6'}
              titleVariant={'hed56'}
              body={matchingStationeryData.body}
              bodyColor={'neutra6'}
              bodyVariant={'dek20'}
              marginBottom={[7, 9]}
            />
            <StyledCtaColumns>
              <CtaColumnLeft width="half" tablet={'half'} mobile="full">
                <CTALink id="save-the-dates-cta" hasChevron typography="featureHed20" href="/cards/wedding/save-the-date/">
                  {matchingStationeryData.saveTheDateCta}
                </CTALink>
              </CtaColumnLeft>
              <CtaColumnRight width="half" tablet={'half'} mobile="full">
                <CTALink id="invitations-cta" hasChevron typography="featureHed20" href="/wedding-invitations/">
                  {matchingStationeryData.invitationsCta}
                </CTALink>
              </CtaColumnRight>
            </StyledCtaColumns>
          </Flex>
          <CloudImageWrapper>
            <StaticPlaceholderCloudImage
              src="wedding-website/stationery/website-v2.jpg"
              alt="Matching Stationery Website"
              width="100%"
              isMainSrcShown={isVisible}
              resizeWidth={1224}
              optimization="default"
            />
            <TopPlaceholderCloudImage
              src="wedding-website/stationery/prints-v2.png"
              alt="Matching Stationery Prints"
              width="100%"
              isMainSrcShown={isVisible}
              resizeWidth={1175}
              optimization="default"
            />
            <BottomPlaceholderCloudImage
              src="wedding-website/stationery/std-v3.png"
              alt="Matching Stationery Std"
              width="100%"
              isMainSrcShown={isVisible}
              resizeWidth={1224}
              optimization="default"
            />
          </CloudImageWrapper>
          <MobilePlaceholderCloudImage
            src="wedding-website/stationery/mobile-static-v2.jpg"
            alt="Matching Stationery Mobile"
            width="280px"
            height="177px"
            isMainSrcShown={isVisibleMobile}
            resizeWidth={280}
            optimization="default"
          />
        </Columns.Column>
      </Columns>
      <BottomWave src="registry-v2/registry-cross/gold-thread-5.svg" optimization="default" />
    </MatchingStationeryWrapper>
  );
};
